/* ============================================================
   Goddess All — Scroll Animation Engine
   IntersectionObserver-based reveal system with counters
   ============================================================ */
(function() {
  'use strict';

  /* --- Scroll Reveal --- */
  var revealEls = document.querySelectorAll('[data-reveal]');
  if (revealEls.length && 'IntersectionObserver' in window) {
    var revealObs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach(function(el) { revealObs.observe(el); });
  } else {
    revealEls.forEach(function(el) { el.classList.add('is-visible'); });
  }

  /* --- Stagger Index --- */
  document.querySelectorAll('[data-stagger]').forEach(function(container) {
    var children = container.children;
    for (var i = 0; i < children.length; i++) {
      children[i].style.setProperty('--stagger-index', i);
    }
  });

  /* --- Animated Counters --- */
  function animateCounter(el) {
    var raw = el.getAttribute('data-count') || el.textContent.trim();
    var match = raw.match(/^([0-9]*\.?[0-9]+)(.*)$/);
    if (!match) return;
    var target = parseFloat(match[1]);
    var suffix = match[2] || '';
    var isDecimal = match[1].indexOf('.') !== -1;
    var duration = 1200;
    var start = performance.now();
    el.textContent = '0' + suffix;

    function tick(now) {
      var t = Math.min((now - start) / duration, 1);
      var ease = 1 - Math.pow(1 - t, 3);
      var val = target * ease;
      el.textContent = (isDecimal ? val.toFixed(1) : Math.round(val)) + suffix;
      if (t < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  var counterEls = document.querySelectorAll('[data-count]');
  if (counterEls.length && 'IntersectionObserver' in window) {
    var counterObs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          animateCounter(entry.target);
          counterObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.3 });
    counterEls.forEach(function(el) { counterObs.observe(el); });
  }

  /* --- Smooth Accordion --- */
  document.querySelectorAll('.goddess-accordion__trigger').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = this.closest('.goddess-accordion__item');
      var isOpen = item.classList.contains('is-open');
      /* Close all in same accordion */
      var accordion = item.parentNode;
      accordion.querySelectorAll('.goddess-accordion__item.is-open').forEach(function(openItem) {
        openItem.classList.remove('is-open');
      });
      /* Toggle clicked */
      if (!isOpen) item.classList.add('is-open');
    });
  });

  /* --- Parallax (lightweight) --- */
  var parallaxEls = document.querySelectorAll('[data-parallax]');
  if (parallaxEls.length) {
    var lastScroll = 0;
    var ticking = false;
    function updateParallax() {
      var scrollY = window.pageYOffset;
      parallaxEls.forEach(function(el) {
        var speed = parseFloat(el.getAttribute('data-parallax')) || 0.15;
        var rect = el.getBoundingClientRect();
        var offset = (rect.top + scrollY - window.innerHeight / 2) * speed;
        el.style.transform = 'translateY(' + offset + 'px)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(updateParallax);
        ticking = true;
      }
    }, { passive: true });
  }

  /* --- Sticky ATC (mobile) --- */
  var mainATC = document.querySelector('.product-form__submit, [data-add-to-cart], .ProductForm__AddToCart');
  var stickyBar = document.getElementById('goddess-sticky-atc');
  if (mainATC && stickyBar && window.innerWidth < 750) {
    var stickyObs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    stickyObs.observe(mainATC);
  }
})();
